import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowNavigationDirection, WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {DartDealService} from "../../deal-list/dart-deals.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {DealModel, DealProjectSummaryModel} from "../../deal-list/deal-list.gql-model";
import {FilteredList} from "../../helpers/filtered-list";
import {AppSettingsService} from "../../app-settings/app-settings.service";
import {GlobalDealSettingsModel, globalDealSettingsModelFactory} from "../../global-deal-settings/global-deal-settings.model";
import {GlobalDealSettingsService} from "../../global-deal-settings/global-deal-settings.service";

@Component({
  templateUrl: "./manage-dart-deals.template.pug",
  providers: [DartDealService, GlobalDealSettingsService],
})
export class ManageDartDealsComponent extends WorkflowStep {
  dartDeals: FilteredList<DealModel> = new FilteredList<DealModel>({
    searchKeys: ["dealKey"],
    exactMatchSearchKeys: ["id"],
  });

  project: DealProjectSummaryModel = new DealProjectSummaryModel({});
  globalDealSettings: GlobalDealSettingsModel = globalDealSettingsModelFactory({});
  targetSystem: string = "legacy";
  error: Error;
  enableGlobalDeals: boolean;
  projectId: string;
  isCurrentMaSuccess: boolean = false;
  POR496_2: boolean = false;
  POR731: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private dartDealService: DartDealService,
    private appSettingsService: AppSettingsService,
    private globalDealSettingsService: GlobalDealSettingsService,
  ) {
    super();
  }

  @handleErrors()
  async importDartDealDialogClosed(event: any) {
    const result = event["value"] as boolean;

    if (result) {
      if (this.project.currentMaStatus === 7) {
        await this.workflowService.setStepStatus(WorkflowStepStatus.Blocked, "createGerpContract");
      }
      await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
      await this.loadData();
    }
  }

  @handleErrors()
  async remove(dealId) {
    await this.dartDealService.remove(dealId,this.workflowTargetInfo.projectId);
    if (this.dartDeals.filtered.length) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
    }
    await this.loadData();
  }

  @handleErrors()
  async loadData() {
    const [{deals, project}, globalDealSettings] = await Promise.all([
      this.dartDealService.getFullList(this.workflowTargetInfo.projectId),
      this.globalDealSettingsService.getGlobalDealSettings(this.workflowTargetInfo.projectId),
    ]);
    
    this.isCurrentMaSuccess = await this.dartDealService.isCurrentMaSuccess(this.workflowTargetInfo.projectId);
    this.project = project;
    this.dartDeals.items = deals;
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;

    this.projectId = this.workflowService.workflowConfig.projectId;
    let por496_2 = false;
    let por496_2_tmc = false;
    const featurePermissions = await this.appSettingsService.getFeaturePermissionsList(["POR496-2", "POR496-2_TMC", "enableGlobalDeals", "POR731_TMC"]);
    por496_2 = featurePermissions["POR496-2"];
    por496_2_tmc = featurePermissions["POR496-2_TMC"];
    this.enableGlobalDeals = featurePermissions["enableGlobalDeals"];
    this.POR496_2 = por496_2 || por496_2_tmc;
    this.globalDealSettings = globalDealSettings;
    this.POR731 = featurePermissions["POR731_TMC"];

    if (!deals.length) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.InProgress);
    }
  }

  @handleErrors()
  async manageDevices(deal: DealModel): Promise<any> {
    this.workflowService.navigate(
      undefined,
      WorkflowNavigationDirection.Manual,
      this.workflowService.workflowConfig.steps.find(it => it.stepName === "friendlyEquipmentName"),
      {filter: deal.dealKey},
    );
  }

  @handleErrors()
  async ready() {
    this.loading = true;
    await this.loadData();
    this.loading = false;
  }
}
